/* eslint-disable import/no-cycle */
import getList from './modules/getList';
import getBreadcrumb from './modules/getBreadcrumb';
import account from './modules/account';
import getTransfer from './modules/hud';
import getSidebar from './modules/sidebar';
import loading from './modules/loading';
import Branch from './modules/Branch';
import userInfo from './modules/userInfo';


const modules = {
  getList,
  getBreadcrumb,
  account,
  getTransfer,
  getSidebar,
  loading,
  Branch,
  userInfo
};
export default modules;
